require("axios");
require("vue");

import { createApp } from 'vue';
import axios from 'axios';

// js call method
function form_user_api_process(tgt_dom_id, form_prm){

    const Cal = {
        data() {
            return {
                info: {},
                loading: true,
                errored: false,

                shubetsu_url_name: form_prm.shubetsu_url_name,
                shubetsu_select_options: form_prm.shubetsu_select_options,
                chikunaka_url_name: form_prm.chikunaka_url_name,
                chikunaka_select_options: form_prm.chikunaka_select_options,
                shokuba_url_name: form_prm.shokuba_url_name,
                shokuba_select_options: form_prm.shokuba_select_options,
                shokuba_url_name_to_infos: form_prm.shokuba_url_name_to_infos,

                tgt_url: '',

            }
        },
        methods: {
            updateChikunakaOpts: function(){
                var vueObj = this;
                var tgt_url = '/api/sel_shubetsu_infos?chikunaka_url_name=' + vueObj.chikunaka_url_name;
                vueObj.tgt_url = tgt_url;

                axios
                    .get(tgt_url)
                    .then(response => {

                        vueObj.shubetsu_select_options = response.data.options;
                        vueObj.shubetsu_url_name = null;

                        vueObj.shokuba_select_options = [];
                        vueObj.shokuba_url_name_to_infos = {};
                        vueObj.shokuba_url_name = null;

                        // console.log(response);
                        // console.log('loaded');
                    })
                    .catch(error => {
                        vueObj.shubetsu_select_options = [];
                        vueObj.shubetsu_url_name = null;
                        vueObj.shokuba_select_options = [];
                        vueObj.shokuba_url_name_to_infos = {};
                        vueObj.shokuba_url_name = null;

                        console.log(error)
                        vueObj.errored = true;
                    })
                    .finally(() => vueObj.loading = false);

            },
            updateShokubaOpts: function(){

                var vueObj = this;
                var tgt_url = '/api/sel_shokuba_infos?shubetsu_url_name=' + vueObj.shubetsu_url_name + '&chikunaka_url_name=' + vueObj.chikunaka_url_name;
                vueObj.tgt_url = tgt_url;

                axios
                    .get(tgt_url)
                    .then(response => {
                        vueObj.shokuba_select_options = response.data.options;
                        vueObj.shokuba_url_name_to_infos = response.data.url_name_to_infos;

                        // 選択候補変わった時は一旦クリア
                        if(!vueObj.shokuba_url_name_to_infos[vueObj.shokuba_url_name]){
                            vueObj.shokuba_url_name = null;
                        }

                        // console.log(response);
                        // console.log('loaded');
                    })
                    .catch(error => {
                        vueObj.shokuba_select_options = [];
                        vueObj.shokuba_url_name_to_infos = {};

                        vueObj.shokuba_url_name = null;

                        console.log(error)
                        vueObj.errored = true;
                    })
                    .finally(() => vueObj.loading = false);

            },
        },
        computed: {
            selectedShokubaName: function (){
                var vueObj = this;
                const tgt_info = vueObj.shokuba_url_name_to_infos[vueObj.shokuba_url_name];
                if(!tgt_info){
                    return null;
                }

                return tgt_info.name;
            },
            selectedShokubaCode: function (){
                var vueObj = this;
                const tgt_info = vueObj.shokuba_url_name_to_infos[vueObj.shokuba_url_name];
                if(!tgt_info){
                    return null;
                }

                return tgt_info.code;
            },
            isExistShokubaOpts: function(){
                var vueObj = this;

                if (!vueObj.shokuba_select_options){
                    return false;
                }
                if (vueObj.shokuba_select_options.length == 0){
                    return false;
                }

                return true;
            },
            isExistShubetsuOpts: function (){
                var vueObj = this;

                if (!vueObj.shubetsu_select_options){
                    return false;
                }
                if (vueObj.shubetsu_select_options.length == 0){
                    return false;
                }

                return true;
            }
        },
        mounted: function(){
            var vueObj = this;
        }
    };
    const app = createApp(Cal).mount(tgt_dom_id);
}

// ここが有効になればグローバルに使えるようになる。
window.form_user_api_process = form_user_api_process;
